// extracted by mini-css-extract-plugin
export default {"mobileTile":"MobileTile_mobileTile__O664U","primary":"MobileTile_primary__1zuXJ","row":"MobileTile_row__soUg+","header":"MobileTile_header__g2cmH","data":"MobileTile_data__yWpfL"};